import { Component } from '@angular/core';

@Component({
  selector: 'app-features-main',
  templateUrl: './features-main.component.html'
})
export class FeaturesMainComponent {
}
